import ApplicationAdapter from './application';

export default class IdScanPageAdapter extends ApplicationAdapter {
  coalesceFindRequests = true;

  pathForType() {
    return 'id-scan-pages';
  }
}
